<template>
    <v-switch
        v-bind:value="value"
        v-on:input="emitInput"
        v-on:change="emitInput"
        :label="label"
        :color="color"
        :disabled="disabled"
        :hide-details="hideDetails"
        :error-messages="errorMessages"
        :true-value="trueValue"
        :false-value="falseValue"
        :multiple="multiple"
        :input-value="value"
    >
        <template #label>
            <slot></slot>
        </template>
    </v-switch>
</template>

<script>

import ada from '../../scss/ada_colors.scss';

export default {
    name: "Toggle",
    props: {
        value: {},
        label: {type: String, default: null},
        disabled: {type: Boolean, default: false},
        hideDetails: {type: [Boolean, String], default: false},
        multiple: {type: Boolean, default: false},
        color: {type: String, default: '#d70364'},
        trueValue: {default: 1},
        falseValue: {default: 0},
        errorMessages: {}
    },
    data: () => {
        return {
            ada
        }
    },
    methods: {
        emitInput($event) {
            this.$emit('input', $event);
        },
    }
}
</script>

<style scoped>
</style>